import { ChangeDetectorRef, Component, HostListener, inject, Renderer2, ChangeDetectionStrategy } from '@angular/core'
import { SidebarComponent } from '../sidebar/sidebar.component'
import { RouterModule } from '@angular/router'
import { TopbarComponent } from '../topbar/topbar.component'
import { Store } from '@ngrx/store'
import { getSidebarsize } from '@/store/layout/layout-selector'
import { changesidebarsize } from '@/store/layout/layout-action'
import { LayoutState } from '@/store/layout/layout-reducers'
import { FooterComponent } from '../footer/footer.component'

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    SidebarComponent,
    RouterModule,
    TopbarComponent,
    FooterComponent
  ],
  templateUrl: './main-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class MainLayoutComponent {
  private store = inject(Store)
  private renderer = inject(Renderer2)
  title!: string;
  subTitle!: string;
  private cdr = inject(ChangeDetectorRef);

  @HostListener('window:resize')
  ngOnInit(): void {
    this.store.select('layout').subscribe((data: LayoutState) => {
      document.documentElement.setAttribute('data-bs-theme', data.LAYOUT_THEME)

      document.documentElement.setAttribute('data-menu-color', data.MENU_COLOR)
      document.documentElement.setAttribute(
        'data-topbar-color',
        data.TOPBAR_COLOR
      )
      document.documentElement.setAttribute('data-sidenav-size', data.MENU_SIZE)
    })
    if (document.documentElement.clientWidth <= 1140) {
      this.onResize()
    }
  }
  onActivate(componentReference: any) {
    this.subTitle = componentReference.subTitle;
    this.title = componentReference.title;
    this.cdr.detectChanges();
  }

  onResize() {
    if (
      document.documentElement.clientWidth <= 1140 &&
      document.documentElement.clientWidth >= 768
    ) {
      this.store.dispatch(changesidebarsize({ size: 'condensed' }))
    } else if (document.documentElement.clientWidth <= 768) {
      this.store.dispatch(changesidebarsize({ size: 'full' }))
    } else {
      this.store.dispatch(changesidebarsize({ size: 'default' }))
      document.documentElement.classList.remove('sidebar-enable')
      const backdrop = document.querySelector('.offcanvas-backdrop')
      if (backdrop) this.renderer.removeChild(document.body, backdrop)
    }

    this.store.select(getSidebarsize).subscribe((size: string) => {
      this.renderer.setAttribute(
        document.documentElement,
        'data-sidenav-size',
        size
      )
    })
  }
  onToggleMobileMenu() {
    this.store.select(getSidebarsize).subscribe((size: any) => {
      document.documentElement.setAttribute('data-sidenav-size', size)
    })

    const size = document.documentElement.getAttribute('data-sidenav-size')

    document.documentElement.classList.toggle('sidebar-enable')
    if (size != 'full') {
      if (document.documentElement.classList.contains('sidebar-enable')) {
        this.store.dispatch(changesidebarsize({ size: 'condensed' }))
      } else {
        this.store.dispatch(changesidebarsize({ size: 'default' }))
      }
    } else {
      this.showBackdrop()
    }
  }
  showBackdrop() {
    const backdrop = this.renderer.createElement('div')
    this.renderer.addClass(backdrop, 'offcanvas-backdrop')
    this.renderer.addClass(backdrop, 'fade')
    this.renderer.addClass(backdrop, 'show')
    this.renderer.appendChild(document.body, backdrop)
    this.renderer.setStyle(document.body, 'overflow', 'hidden')

    if (window.innerWidth > 1040) {
      this.renderer.setStyle(document.body, 'paddingRight', '15px')
    }

    this.renderer.listen(backdrop, 'click', () => {
      document.documentElement.classList.remove('sidebar-enable')
      this.renderer.removeChild(document.body, backdrop)
      this.renderer.setStyle(document.body, 'overflow', null)
      this.renderer.setStyle(document.body, 'paddingRight', null)
    })
  }
}
